// client/legend-cms/src/worldCupMatches/index.js
import WorldCupMatchList from './WorldCupMatchList';
import WorldCupMatchCreate from './WorldCupMatchCreate';
import WorldCupMatchEdit from './WorldCupMatchEdit';
import SportsSoccerIcon from '@material-ui/icons/SportsSoccer';

const worldCupMatchesResource = {
  list: WorldCupMatchList,
  create: WorldCupMatchCreate,
  edit: WorldCupMatchEdit,
  icon: SportsSoccerIcon,
};

export default worldCupMatchesResource;
